import { IHe } from "../../../model/respone/category/IHe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHeActionTypeDefine = {
    LOAD_START: {} as number | undefined,
    LOAD_SUCCESS: {} as IHe[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IHe,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as IHe,
    SAVE_SUCCESS: {} as IHe,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eHeActionTypeIds = generateActionTypeIds(eHeActionTypeDefine, "HE");

export type IHeActions = IGenericActionType<typeof eHeActionTypeDefine, "HE">;
